__turbopack_context__.v({
  "accent": "EBBLandingPage-module__9K_zcW__accent",
  "bookCover": "EBBLandingPage-module__9K_zcW__bookCover",
  "bookLink": "EBBLandingPage-module__9K_zcW__bookLink",
  "carouselCard": "EBBLandingPage-module__9K_zcW__carouselCard",
  "carouselTrack": "EBBLandingPage-module__9K_zcW__carouselTrack",
  "carouselWrap": "EBBLandingPage-module__9K_zcW__carouselWrap",
  "closing": "EBBLandingPage-module__9K_zcW__closing",
  "closingBanner": "EBBLandingPage-module__9K_zcW__closingBanner",
  "coralCta": "EBBLandingPage-module__9K_zcW__coralCta",
  "ctaRow": "EBBLandingPage-module__9K_zcW__ctaRow",
  "deals": "EBBLandingPage-module__9K_zcW__deals",
  "dealsSub": "EBBLandingPage-module__9K_zcW__dealsSub",
  "dot": "EBBLandingPage-module__9K_zcW__dot",
  "dotActive": "EBBLandingPage-module__9K_zcW__dotActive",
  "dots": "EBBLandingPage-module__9K_zcW__dots",
  "emailInput": "EBBLandingPage-module__9K_zcW__emailInput",
  "emailRow": "EBBLandingPage-module__9K_zcW__emailRow",
  "feature": "EBBLandingPage-module__9K_zcW__feature",
  "featureVisual": "EBBLandingPage-module__9K_zcW__featureVisual",
  "features": "EBBLandingPage-module__9K_zcW__features",
  "googleWrap": "EBBLandingPage-module__9K_zcW__googleWrap",
  "header": "EBBLandingPage-module__9K_zcW__header",
  "headerRow": "EBBLandingPage-module__9K_zcW__headerRow",
  "headerScrolled": "EBBLandingPage-module__9K_zcW__headerScrolled",
  "headerSolid": "EBBLandingPage-module__9K_zcW__headerSolid",
  "headerSticky": "EBBLandingPage-module__9K_zcW__headerSticky",
  "hero": "EBBLandingPage-module__9K_zcW__hero",
  "heroBanner": "EBBLandingPage-module__9K_zcW__heroBanner",
  "heroCard": "EBBLandingPage-module__9K_zcW__heroCard",
  "loginBtn": "EBBLandingPage-module__9K_zcW__loginBtn",
  "logoFallback": "EBBLandingPage-module__9K_zcW__logoFallback",
  "logoImage": "EBBLandingPage-module__9K_zcW__logoImage",
  "logoWrap": "EBBLandingPage-module__9K_zcW__logoWrap",
  "orDivider": "EBBLandingPage-module__9K_zcW__orDivider",
  "page": "EBBLandingPage-module__9K_zcW__page",
  "pointImage": "EBBLandingPage-module__9K_zcW__pointImage",
  "priceBadge": "EBBLandingPage-module__9K_zcW__priceBadge",
  "retailerLogos": "EBBLandingPage-module__9K_zcW__retailerLogos",
  "signupError": "EBBLandingPage-module__9K_zcW__signupError",
  "signupForm": "EBBLandingPage-module__9K_zcW__signupForm",
  "signupForm_closing": "EBBLandingPage-module__9K_zcW__signupForm_closing",
  "signupForm_modal": "EBBLandingPage-module__9K_zcW__signupForm_modal",
  "signupForm_simpleClosing": "EBBLandingPage-module__9K_zcW__signupForm_simpleClosing",
  "signupForm_simpleHero": "EBBLandingPage-module__9K_zcW__signupForm_simpleHero",
  "signupForm_sticky": "EBBLandingPage-module__9K_zcW__signupForm_sticky",
  "signupModalHeadline": "EBBLandingPage-module__9K_zcW__signupModalHeadline",
  "signupModalShell": "EBBLandingPage-module__9K_zcW__signupModalShell",
  "srOnly": "EBBLandingPage-module__9K_zcW__srOnly",
  "starImage": "EBBLandingPage-module__9K_zcW__starImage",
  "stars": "EBBLandingPage-module__9K_zcW__stars",
  "startReadingBtn": "EBBLandingPage-module__9K_zcW__startReadingBtn",
  "stickyDesktopForm": "EBBLandingPage-module__9K_zcW__stickyDesktopForm",
  "stickyHeadline": "EBBLandingPage-module__9K_zcW__stickyHeadline",
  "stickyMobileCta": "EBBLandingPage-module__9K_zcW__stickyMobileCta",
  "stickySignup": "EBBLandingPage-module__9K_zcW__stickySignup",
  "stickySignupInner": "EBBLandingPage-module__9K_zcW__stickySignupInner",
  "stickySignupOpen": "EBBLandingPage-module__9K_zcW__stickySignupOpen",
  "testimonialCard": "EBBLandingPage-module__9K_zcW__testimonialCard",
  "testimonials": "EBBLandingPage-module__9K_zcW__testimonials",
  "testimonialsDesktop": "EBBLandingPage-module__9K_zcW__testimonialsDesktop",
  "testimonialsMobile": "EBBLandingPage-module__9K_zcW__testimonialsMobile",
});
